import { NavLink, useLocation } from "react-router-dom";
import { LuHouse as FiHome, LuGlobe as FiCompass, LuMessageCircle as FiMessageCircle, LuUser as FiUser } from "react-icons/lu";
import useUnreadMessages from "../hooks/useUnreadMessages";
export default function MainNavigation({ mobile = false }) {
  const unread = useUnreadMessages();
  const { pathname } = useLocation();
  const items = [
    [
      "Home",
      "/dashboard",
      FiHome,
      ["/dashboard", "/jobs", "/post-job", "/funds"],
    ],
    ["Discover", "/discover", FiCompass, ["/discover", "/user-profile"]],
    [
      "Messages",
      "/chats",
      FiMessageCircle,
      ["/chats", "/chat/", "/group-chat", "/create-group"],
    ],
    [
      "Profile",
      "/profile",
      FiUser,
      [
        "/profile",
        "/settings",
        "/edit-profile",
        "/bank-payouts",
        "/my-applications",
      ],
    ],
  ];
  return (
    <nav
      aria-label={mobile ? "Mobile navigation" : "Main navigation"}
      className={mobile ? "grid grid-cols-4 gap-1" : "space-y-2"}
    >
      {items.map(([label, to, Icon, paths]) => {
        const active = paths.some((p) => pathname.startsWith(p));
        return (
          <NavLink
            key={label}
            to={to}
            aria-current={active ? "page" : undefined}
            className={`relative flex items-center gap-3 font-medium rounded-xl ${mobile ? "flex-col gap-1 py-3 text-xs" : "px-4 py-3 text-base"} ${active ? "bg-[#327691] text-white" : "hover:bg-black/5 dark:hover:bg-white/10"}`}
          >
            <span className="relative">
              <Icon size={22} />
              {label === "Messages" && unread > 0 && (
                <b className="absolute -right-3 -top-2 rounded-full bg-red-600 text-white text-[10px] px-1">
                  {unread > 99 ? "99+" : unread}
                </b>
              )}
            </span>
            <span>{label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
